import useToggle from '@/shared/hooks/useVisible';
import { usePersistStore } from '@/shared/lib/store';
import { VivaModalForm } from '@/shared/ui';
import { useEffect } from 'react';
import { useState } from 'react';

export const ClassSharePopup = ({
    shareUrl,
    title,
    startDate,
    endDate,
    timerWhether,
    hours,
    minutes,
}: {
    shareUrl: string;
    title: string;
    startDate: string;
    endDate: string;
    timerWhether: boolean;
    hours: number;
    minutes: number;
}) => {
    const { sMyClassMemberList } = usePersistStore();
    const [selectOpen1, setSelectOpen1] = useToggle();
    const [selectOpen2, setSelectOpen2] = useToggle();
    const [selectClass, setSelectClass] = useState<API.MyClassMemberList.ClassInfo>();
    const [selectType, setSelectType] = useState<string>('notice');

    useEffect(() => {
        sMyClassMemberList && setSelectClass(sMyClassMemberList[0]?.classInfo);
    }, [sMyClassMemberList]);

    const onShareViva = () => {
        window.open(
            `https://${import.meta.env.MODE === 'development' || import.meta.env.VITE_DEPLOY === 'dev' ? 'dev-' : ''}vivaclass.vivasam.com/ourclass/${selectType}/ext/write?classSeq=${
                selectClass?.classSeq
            }&url=${shareUrl}&extTitle=${title}&extStartDate=${startDate}&extEndDate=${endDate}${timerWhether ? `&extContents=- 제한 시간 : ${hours}시간 ${minutes > 0 ? minutes + '분 ' : ''}평가` : ''}&extIsAllMember=true&extIsOffline=true&linkage=V`,
            '_blank'
        );
    };

    return (
        <VivaModalForm
            onOk={onShareViva}
            popupId="viva-share-class"
            title={
                <p className="tit">
                    우리반 <strong>비바클래스</strong>에 공유하세요.
                </p>
            }
            description={
                <>
                    <strong>수업자료를 학생들에게 공유해보세요</strong>
                    클래스 선택 시, 해당 클래스의 게시판에
                    <br />
                    수업자료가 바로 첨부 됩니다.
                    <br />
                </>
            }
            children={
                <div className="formWrap">
                    <form id="selForm1" name="selForm">
                        <div className="formCont">
                            <div className="dropdown-wrap flex_c">
                                <div className="dropdown-box">
                                    <div className={`dropdown-btn ${selectOpen1 && 'isOpen'}`}>
                                        <button type="button" onClick={setSelectOpen1}>
                                            {selectClass?.schName?.slice(0, 3) +
                                                ' ' +
                                                selectClass?.clsName}
                                        </button>
                                    </div>
                                    <div className={`dropdown-content ${selectOpen1 && 'isOpen'}`}>
                                        <div className="option-type-default">
                                            {sMyClassMemberList?.map((item, idx) => {
                                                if (item?.classInfo?.classState !== '1') return;
                                                return (
                                                    <div
                                                        key={`class-share-dropdown-${idx}`}
                                                        className={`option ${selectClass?.classSeq === item.classInfo.classSeq && 'isCurrent'}`}
                                                    >
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setSelectClass(item.classInfo);
                                                                setSelectOpen1();
                                                            }}
                                                        >
                                                            {item.classInfo?.schName?.slice(0, 3) +
                                                                ' ' +
                                                                item.classInfo.clsName}
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="dropdown-box">
                                    <div className={`dropdown-btn ${selectOpen2 && 'isOpen'}`}>
                                        <button type="button" onClick={setSelectOpen2}>
                                            {selectType === 'notice' ? '공지' : '숙제'} 게시판
                                        </button>
                                    </div>
                                    <div className={`dropdown-content ${selectOpen2 && 'isOpen'}`}>
                                        <div className="option-type-default">
                                            <div
                                                className={`option ${selectType === 'notice' && 'isCurrent'}`}
                                            >
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setSelectType('notice');
                                                        setSelectOpen2();
                                                    }}
                                                >
                                                    공지 게시판
                                                </button>
                                            </div>
                                            <div
                                                className={`option ${selectType === 'homework' && 'isCurrent'}`}
                                                onClick={() => {
                                                    setSelectType('homework');
                                                    setSelectOpen2();
                                                }}
                                            >
                                                <button type="button">숙제 게시판</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            }
            btnText="지금 바로 공유하기"
        />
    );
};
